import React from 'react';

import {
  Download,
} from '../../../../components';

import '../style.scss';

const ParagraphDownloadGetStarted = ({ entity }) => {
  const downloads = entity.getIn(['field_download_s_']);

  return (
    <div className="Paragraph ParagraphDownload">
      {downloads && downloads.size > 0 && (
        downloads.map((download, index) => {
          const uuid = download.getIn(['entity', 'uuid', 0, 'value']);
          const downloadTitle = download.get('title');
          const downloadLink = download.get('source');
          const ext = downloadLink.split('.').pop();

          return (
            <Download
              key={uuid}
              title={downloadTitle}
              link={downloadLink}
              fileType={ext}
            />
          );
        })
      )}
    </div>
  );
};

export default ParagraphDownloadGetStarted;
